<template>
  <div
    :class="[
      'category-item',
      isSelected && 'category-selected',
      (disabled || noMatch) && 'category-disabled',
    ]"
    @click="handleClick"
  >
    <transition name="slide-fade">
      <div class="check-icon-container" v-if="isSelected">
        <font-awesome-icon
          icon="fa-solid fa-circle-check"
          size="2x"
          :style="{ color: 'var(--theme-hover)' }"
        />
      </div>
    </transition>

    <div v-if="disabled || noMatch" class="category-disabled-overlay">
      <div>
        <font-awesome-icon
          icon="fa-solid fa-ban"
          size="6x"
          :style="{ color: 'rgb(175, 0, 0)', marginBottom: '15px' }"
        />
        <p v-if="noProducts" style="text-align: center; margin: auto">
          This category has no products available
        </p>
        <p v-else style="text-align: center; margin: auto">
          Door de eerder gegeven antwoorden is deze optie niet mogelijk. Ga zo
          nodig terug.
        </p>
      </div>
    </div>
    <img
      class="category-image"
      :src="category.image?.src || shopSettings.defaultImage"
    />
    <div class="category-content">
      <h3>
        {{ category.name }}
      </h3>
      <p>
        {{ category.description }}
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "CategoryItem",
  props: {
    category: {
      type: Object,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isSelected: {
      type: Boolean,
      default: false,
    },
    noProducts: {
      type: Boolean,
      default: false,
    },
    autoDisable: {
      type: Boolean,
      default: false,
    },
    filteredProducts: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    handleClick(e) {
      if (!this.disabled && !this.noMatch) {
        this.$emit("click", e);
      }
    },
  },
  computed: {
    noMatch() {
      if (!this.autoDisable) {
        return false;
      }

      const found = this.filteredProducts.find((product) => {
        const prod = product.categories.find(
          (category) => category.id === this.category.id
        );
        return prod ? true : false;
      });

      return !found;
    },
  },
  mounted() {
    if ((this.autoDisable && this.noMatch) || this.disabled) {
      this.$emit("auto-deselect", this.category);
    }
  },
};
</script>

<style scoped>
.check-icon-container {
  position: absolute;
}

.category-disabled-overlay {
  height: 100%;
  width: 100%;
  text-align: center;
  display: flex;
  align-items: center;
  position: absolute;
  text-align: center;
  justify-content: center;
  padding: 3rem;
  background-color: rgba(255, 255, 255, 0.7);
  top: 0;
  left: 0;
}

.category-disabled-overlay p {
  color: rgb(175, 0, 0);
}

.category-item {
  border: 1.5px solid #ccc;
  border-radius: 10px;
  padding: 2rem;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: border-color 0.2s;
}

.category-item.category-disabled {
  border: none;
  cursor: default;
}

.category-item:not(.category-disabled):hover,
.category-item:not(.category-disabled).category-selected {
  border-color: var(--theme-hover);
  transition: border-color 0.2s;
}

.category-image {
  height: 300px;
  margin: 0 auto;
  margin-bottom: 1em;
  border-radius: 5px;
  object-fit: cover;
}

.category-content {
  text-align: center;
}
</style>
